<!-- claire-saved-chats.component.html — EN-5079 Claire's Saved chats list -->
<!-- Masked in Datadog session replay: titles and search terms are the user's own words. -->
<div class="saved-page" data-dd-privacy="mask">
	<div class="saved-container">
		<div class="saved-header">
			<div class="saved-title">
				<img class="claire-avatar" src="assets/img/claire/claire-avatar.png" alt="Claire" />
				<span>Saved chats</span>
			</div>
			<a class="new-chat-link" routerLink="/claire/new"> <span class="material-icons">add</span> New chat </a>
		</div>

		<div class="saved-search">
			<span class="material-icons">search</span>
			<input
				type="search"
				class="saved-search-input"
				placeholder="Search your saved chats"
				[ngModel]="search"
				(ngModelChange)="onSearchChange($event)"
				aria-label="Search your saved chats"
				data-dd-action-name="Search saved chats"
			/>
		</div>

		<div class="saved-error" *ngIf="errorMessage">
			<span class="material-icons">error_outline</span> {{ errorMessage }}
		</div>

		<div class="saved-empty" *ngIf="!isLoading && !errorMessage && chats.length === 0">
			<ng-container *ngIf="search.trim(); else noChats">No saved chats match "{{ search.trim() }}".</ng-container>
			<ng-template #noChats>
				You have no saved chats yet. In a conversation with Claire, choose <strong>Save chat</strong> to keep it here.
			</ng-template>
		</div>

		<ul class="saved-list" *ngIf="chats.length > 0">
			<li class="saved-item" *ngFor="let chat of chats; trackBy: trackById" [class.pinned]="chat.isPinned">
				<span class="material-icons saved-pin-mark" *ngIf="chat.isPinned" title="Pinned">push_pin</span>

				<div class="saved-main">
					<ng-container *ngIf="editingId !== chat.id; else renaming">
						<a class="saved-chat-title" [routerLink]="[savedChatPath, chat.id]" data-dd-action-name="Open saved chat">{{
							chat.title
						}}</a>
					</ng-container>
					<ng-template #renaming>
						<input
							class="saved-rename-input"
							[(ngModel)]="editTitle"
							[maxlength]="maxTitleLength"
							(keydown.enter)="saveRename(chat)"
							(keydown.escape)="cancelRename()"
							(blur)="saveRename(chat)"
							aria-label="Chat title"
							data-dd-action-name="Rename saved chat"
							autofocus
						/>
					</ng-template>
					<div class="saved-meta">{{ chat.lastMessageUtc | date : 'MMM d, y, h:mm a' }}</div>
				</div>

				<div class="saved-actions">
					<button type="button" class="saved-action" (click)="startRename(chat)" title="Rename">
						<span class="material-icons">edit</span>
					</button>
					<button
						type="button"
						class="saved-action"
						[class.active]="chat.isPinned"
						(click)="togglePin(chat)"
						[title]="chat.isPinned ? 'Unpin' : 'Pin to the top'"
					>
						<span class="material-icons">push_pin</span>
					</button>
					<button type="button" class="saved-action danger" (click)="confirmDelete(chat)" title="Delete">
						<span class="material-icons">delete_outline</span>
					</button>
				</div>
			</li>
		</ul>

		<div class="saved-loading" *ngIf="isLoading">Loading…</div>

		<button
			type="button"
			class="load-more-btn"
			*ngIf="nextCursor && !isLoading"
			(click)="loadMore()"
			[disabled]="isLoadingMore"
		>
			{{ isLoadingMore ? 'Loading…' : 'Load more' }}
		</button>
	</div>
</div>
